<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <BannerCreateAndUpdateFormItems :form="form" :data="banner" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import VForm from '@/components/VForm.vue'
import BannerCreateAndUpdateFormItems from '@/components/BannerCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        BannerCreateAndUpdateFormItems,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        banner () {
            return this.$store.getters[Getters.banner.GET_BANNER](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_BANNER, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
